import { render, staticRenderFns } from "./MessageArea.vue?vue&type=template&id=54a29551"
import script from "./MessageArea.vue?vue&type=script&lang=js"
export * from "./MessageArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports